import { DataGrid, LoadPanel, ScrollView } from 'devextreme-react';
import Box, { Item } from 'devextreme-react/box';
import { useCallback, useEffect, useState } from 'react';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useAppDispatch, useAppSelector } from '../../../../../contexts/hooks';
import { useScreenSize } from '../../../../../utils/media-query';
import { showModalHistory } from '../../../../../contexts/slices/orders';
import 'devextreme-react/text-area';
import { Chart, Series, ArgumentAxis, CommonSeriesSettings, Grid, Legend, Margin, Tooltip as ToolTipChart, Label, Format, CommonAxisSettings, Title, Subtitle } from 'devextreme-react/chart';
import { ResultEstadoResult } from '../../../../../types/types.orders';
import { UseApiResults } from '../../../../../api/api.results';
import { ResultTypeResult } from '../../../../../types/types.analitos';
import { Column, Selection } from 'devextreme-react/data-grid';
import moment from 'moment';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Export } from 'devextreme-react/circular-gauge';

export const ModalResultHistory = () => {
  const dataModal = useAppSelector((x) => x.globalOrders.CurrentOrder.ModalHistory);
  //const idPc = useAppSelector((x) => x.globalOrders.CurrentOrder.PatientData.Pc_Id);
  const { getHistoryPatient } = UseApiResults();
  const [data, setData] = useState<any[]>([]);
  const [dataChart, setDataChart] = useState<any[]>([]);
  const [currentTemplate, setCurrentTemplate] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const { isMedium, isSmall, isXSmall} = useScreenSize();
  const [loading, setLoading] = useState<boolean>(false);
  const patient = useAppSelector((x) => x.globalOrders.CurrentOrder.PatientData);
  const Prm_ResImprimir = useAppSelector((x) => x.userInfo.Permissions?.Prm_ResImprimir);

  useEffect(() => {
    if (dataModal && dataModal.Visible) {      
      setCurrentTemplate([]);
      setLoading(true);
      getHistoryPatient(dataModal.Pc_Id, dataModal.An_Id)
        .then((res) => {
          setData(res); 
          if (dataModal.An_Tr_Id === ResultTypeResult.NUMERICO || dataModal.An_Tr_Id === ResultTypeResult.FORMULA) {
            const newData = [...res];
            newData.forEach((obj) => {
              obj.Result = parseFloat(obj.Result);
              obj.Date = moment(obj.Date).format('DD/MM/YYYY');
            });
            setDataChart(newData);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [dataModal]);

  const getHistoryByResult = useCallback(() => {
    if (!dataModal?.An_Tr_Id) {
      return <div>Tipo de resultado incorrecto</div>;
    }
    switch (dataModal?.An_Tr_Id) {
      case ResultTypeResult.FORMULA: //Numericos
      case ResultTypeResult.NUMERICO:
        return (
          <div>
            <Chart palette='Soft Blue' dataSource={dataChart}>
              <Title text={`${patient.Pc_Nombre} ${patient.Pc_Apellido1 || ''} ${patient.Pc_Apellido2 || ''}`}>
                <Subtitle text={`${dataModal.An_Nombre}: Evolutivo últimos ${data.length > 10 ? '10' : data.length} resultados`} />
              </Title>
              <CommonSeriesSettings argumentField='Date' type='spline' />
              <Series key={'Result'} valueField='Result' name='Result' />
              <Margin bottom={20} />
              <CommonAxisSettings>
                <Grid visible={true} />
              </CommonAxisSettings>
              <ArgumentAxis allowDecimals={false} axisDivisionFactor={60}>
                <Label />
              </ArgumentAxis>
              <ToolTipChart enabled={true} zIndex={5000} format='exponential' customizeTooltip={tooltipTemplate} />
              <Export enabled={Prm_ResImprimir} formats={['PDF', 'PNG']} margin={30} />
              <Legend verticalAlignment='top' horizontalAlignment='right' visible={false} />
            </Chart>
          </div>
        );
      case ResultTypeResult.PLANTILLA: //Plantillas
        return (
          <div>
            {currentTemplate.map((x: any) => {
              return (
                <div key={x.Group} className='tooltip-content'>
                  <h6 className='tooltip-title'>{x.Group}</h6>
                  {x.Items.map((y: any) => {
                    return (
                      <p key={y.Key} className='tooltip-item'>
                        <strong>&nbsp;&nbsp;{y.Label}: </strong>
                        {y.Value}
                      </p>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      default: //Textuales
        return <div>Textual</div>;
    }
  }, [dataModal, currentTemplate, dataChart]);

  const handleClose = useCallback(() => {
    dispatch(showModalHistory({ Visible: false, An_Id: -1, An_Nombre: '', An_Plantilla: '', Res_Estado: ResultEstadoResult.Validado, Res_Id: -1, Res_Resultado: '', Update:false, Pc_Id: -1 }));
  }, []);

  const onExporting = useCallback((e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `HISTORICO - ${patient.Pc_Nombre} ${patient.Pc_Apellido1 || ''} ${patient.Pc_Apellido2 || ''}.xlsx`);
      });
    });
  }, []);

  const handleChangeSelection = useCallback(
    (e) => {
      if (dataModal?.An_Tr_Id === ResultTypeResult.PLANTILLA) {
        setCurrentTemplate(JSON.parse(e.selectedRowsData[0].Result));
      }
    },
    [dataModal]
  );

  return (
    <Popup visible={dataModal?.Visible || false} fullScreen={isMedium || isSmall || isXSmall} onHidden={handleClose} width={'90%'} height={'90%'} title={dataModal?.An_Nombre || ''}>
      <ScrollView>
        <Box direction='row' width={'100%'} height={'100%'}>
          {(dataModal?.An_Tr_Id === ResultTypeResult.PLANTILLA || dataModal?.An_Tr_Id === ResultTypeResult.NUMERICO || dataModal?.An_Tr_Id === ResultTypeResult.FORMULA) && (
            <Item ratio={3}>
              <div className='historyMargin'>{getHistoryByResult()}</div>
            </Item>
          )}
          <Item ratio={dataModal?.An_Tr_Id === ResultTypeResult.PLANTILLA || dataModal?.An_Tr_Id === ResultTypeResult.NUMERICO || dataModal?.An_Tr_Id === ResultTypeResult.FORMULA ? 1 : 4}>
            <DataGrid id='dataTg' dataSource={data} onExporting={onExporting} onSelectionChanged={handleChangeSelection}>
              <Selection mode='single' />
              <Export enabled={true} />
              <Column dataField='Date' caption='Fecha' dataType='date' alignment='center' />
              <Column dataField='OrdNum' caption='Orden' alignment='center' />
              {dataModal?.An_Tr_Id !== ResultTypeResult.IMAGEN && dataModal?.An_Tr_Id !== ResultTypeResult.PLANTILLA && <Column dataField='Result' caption='Resultado' alignment='center' />}
            </DataGrid>
          </Item>
        </Box>
        <LoadPanel visible={loading} position={{ of: '#dataTg' }} />
      </ScrollView>
      <ToolbarItem widget='dxButton' toolbar='bottom' location='after' options={{ text: 'CERRAR', type: 'normal', onClick: handleClose }} />
    </Popup>
  );
};

function tooltipTemplate(pointInfo) {
  return {
    html: `<div><div class="tooltip-header">Fecha: ${pointInfo.argumentText}</div><div class="tooltip-body"><div class="series-name"><span class='top-series-name'>Resultado: ${pointInfo.originalValue}</span> </div></div>`,
  };
}
